import React, { useEffect, useMemo, useRef, useState } from 'react'
import { useSelector } from 'react-redux';
import { selectGtoState, useDispatch } from "../../../../stateManagement/redux"
import { ReportInterface } from '../../../../stateManagement/redux/slices/gerencia_tecnica/interfaces';
import { projectList } from '../../../../shared/util/projectList';
import ReportCard from './card';
import './styles.scss'
import ButtonBig from '../../../../shared/components/button_big';
import generatePDF, { Options } from 'react-to-pdf';
import { delay } from '../../consolidate_files/upload-modal/fileRow';
import JSZip from "jszip";
import { saveAs } from "file-saver";
import { Box, CircularProgress, LinearProgress, Stack } from '@mui/material';

export const CartListForReport = ({ report, filters }: { report: ReportInterface, filters: any }) => {

  const mainState = useSelector(selectGtoState);

  const [showListOfActivities, setShowListOfActivities] = useState(true)
  const [reloadCartComponent, setReloadCartComponent] = useState(false)

  const [activeActivityWithCard, setActiveActivityWithCard] = useState<any>([])
  const [setSizeToGeneratePdf, setsetSizeToGeneratePdf] = useState(false)

  const [loading, setLoading] = useState(false)

  const [cardsWithData, setcardsWithData] = useState<any[]>([])

  const targetRef = useRef<any>();

  useEffect(() => {

    const cardsWithData: any[] = []

    for (const element of mainState?.reportWithData || []) {

      let dynValue = JSON.parse(element?.['dynCarts'])

      if (dynValue?.length > 0) {
        dynValue.forEach((cart: any) => {
          cardsWithData.push({ ...element, ...cart })
        })
      }

    }

    setcardsWithData(cardsWithData)

  }, [mainState?.reportWithData])



  const onClickDownnloadPdf = async () => {

    if (showListOfActivities) {
      setShowListOfActivities(false)

      for (const activity of cardsWithData || []) {
        try {
          setActiveActivityWithCard(activity)
          setReloadCartComponent(true)
          await delay(500)
          setsetSizeToGeneratePdf(true)
          setReloadCartComponent(false)
          await delay(1000)

          const options: Options = {
            filename: `${activity?.['Pozo']}.pdf`,
            method: 'save',
            page: { format: 'letter', orientation: 'landscape', margin: { top: 22, right: 22, bottom: 22, left: 22 } },
            overrides: { pdf: { compress: true } },
            canvas: { qualityRatio: 0.2 }
          }

          const pdfBlob = await generatePDF(targetRef, { ...options }); // Generate Blob directly


        }
        catch (error) {
          console.log({ error })
        }

      }
      setsetSizeToGeneratePdf(false)
      setShowListOfActivities(true)

    } else {
      setReloadCartComponent(true)
      await delay(500)
      setsetSizeToGeneratePdf(true)
      setReloadCartComponent(false)
      await delay(1000)

      const options: Options = {
        filename: `${activeActivityWithCard?.['Pozo']}.pdf`,
        method: 'open',
        page: { format: 'letter', orientation: 'landscape', margin: { top: 22, right: 22, bottom: 0, left: 22 } },
        // page: { format: 'letter', orientation: 'landscape', margin: { top: 22, right: 10, bottom: 0, left: 10 } },
        overrides: { pdf: { compress: true } },
        canvas: { qualityRatio: 0.2 }

      }


      await generatePDF(targetRef, options)
      setsetSizeToGeneratePdf(false)
    }
  }

  const testClickPdf = async () => {
    setShowListOfActivities(false);
    setLoading(true);
    const activity = cardsWithData[0]
    setActiveActivityWithCard(activity);
    setReloadCartComponent(true);
    await delay(100);
    setsetSizeToGeneratePdf(true);
    setReloadCartComponent(false);
    await delay(300);
  }

  const onClickDownloadPdfV2 = async () => {
    const zip = new JSZip(); // Create a new ZIP archive

    if (showListOfActivities) {
      setShowListOfActivities(false);

      let i = 1;

      setLoading(true);
      for (const activity of cardsWithData || []) {

        try {
          setActiveActivityWithCard(activity);
          setReloadCartComponent(true);
          await delay(100);
          setsetSizeToGeneratePdf(true);
          setReloadCartComponent(false);
          await delay(300);

          const options: Options = {
            filename: `${activity?.["Pozo"]}.pdf`,
            method: 'build',
            page: { format: "letter", orientation: "landscape", margin: { top: 12, right: 22, bottom: 0, left: 22 } },
            overrides: { pdf: { compress: true, format:'letter'} },
            canvas: { qualityRatio: 0.2 },
          };

          const pdfDoc = await generatePDF(targetRef, options);

          // Convert jsPDF object to Blob
          const pdfBlob = pdfDoc.output('blob');

          // Add the generated PDF Blob to the ZIP archive
          zip.file(`${activity?.["Pozo"]}.pdf`, pdfBlob);
          i++;
        } catch (error) {
          console.log({ error });
        }
      }
     
      setsetSizeToGeneratePdf(false);
      setShowListOfActivities(true);

      // Generate the ZIP file and trigger the download
      const zipBlob = await zip.generateAsync({ type: "blob" });
      saveAs(zipBlob, "all_activities.zip");
      setLoading(false);
    } else {
      setReloadCartComponent(true)
      await delay(500)
      setsetSizeToGeneratePdf(true)
      setReloadCartComponent(false)
      await delay(1000)

      const options: Options = {
        filename: `${activeActivityWithCard?.['Pozo']}.pdf`,
        method: 'open',
        page: { format: 'letter', orientation: 'landscape', margin: { top: 22, right: 22, bottom: 0, left: 22 } },
        // page: { format: 'letter', orientation: 'landscape', margin: { top: 22, right: 10, bottom: 0, left: 10 } },
        overrides: { pdf: { compress: true } },
        canvas: { qualityRatio: 0.2 }

      }
      await generatePDF(targetRef, options)
      setsetSizeToGeneratePdf(false)
    }
  };



  return (
    <div>
      <div className="container_cart_list_button_container">
        <div className='loadingSection'>
          {loading && (
            <>
              <CircularProgress disableShrink />
              Generado los archivos PDF......
            </>
          )}
        </div>
        <div className='button_right'>
          <ButtonBig text='Generar PDF' icon='/assets/icons/download-report.svg' onClick={() => onClickDownloadPdfV2()} />
          <ButtonBig text='Calcular Carta fondo' icon='/assets/icons/calculate.svg' onClick={() => { }} />
        </div>
      </div>
      <div className="container_cart_list">
        {showListOfActivities ? (
          <>
            {cardsWithData.map((a, i) => (
              // <div ref={targetRef} key={i}>
              <ReportCard
                activeActivityWithCard={a}
                key={i}
                activityValidation={[]}
                activeFieldForActivities={""}
                targetRef={targetRef}
                setSizeToGeneratePdf={false}
              />
              // </div>
            ))}
          </>
        ) : (
          <>
            {!reloadCartComponent && ((
              // <div ref={targetRef} className={`${setSizeToGeneratePdf ? "consolidate_files_container_letter_container" : ""}`}>
              <ReportCard
                activityValidation={[]}
                activeActivityWithCard={activeActivityWithCard}
                activeFieldForActivities={""}
                targetRef={targetRef}
                setSizeToGeneratePdf={setSizeToGeneratePdf}
              />
              // </div>
            ))}
          </>
        )}
      </div>
    </div>

  )
}